export const STATUS_OPTIONS = [
  { value: 0, name: 'Todos' },
  { value: 1, name: 'Ativo' },
  { value: 2, name: 'Inativo' }
];

export const DEEP_LINKING_FILTER_OPTIONS = [
  { value: 0, name: 'Todos' },
  { value: 1, name: 'Sim' },
  { value: 2, name: 'Não' }
];

export const DESCRICAO_MAX_LENGTH = 150;

export const IMAGE_DIMENSION_TOLERANCE = 0.2;

/** Web / Todos — banner horizontal */
export const IMAGE_WEB_WIDTH = 1920;
export const IMAGE_WEB_HEIGHT = 400;

/** App Mobile / Web Mobile — proporção 8:7 */
export const IMAGE_MOBILE_WIDTH = 1280;
export const IMAGE_MOBILE_HEIGHT = 1120;

/** Mantidos para compatibilidade com imports existentes */
export const IMAGE_TARGET_WIDTH = IMAGE_WEB_WIDTH;
export const IMAGE_TARGET_HEIGHT = IMAGE_WEB_HEIGHT;

export const TIPO_PLATAFORMA = {
  TODOS: 1,
  APP_MOBILE: 2,
  WEB: 3,
  WEB_MOBILE: 4
};

export const getDestaqueImageTarget = (tipoPlataformaId) => {
  const isMobile =
    tipoPlataformaId === TIPO_PLATAFORMA.APP_MOBILE ||
    tipoPlataformaId === TIPO_PLATAFORMA.WEB_MOBILE;

  if (isMobile) {
    return {
      width: IMAGE_MOBILE_WIDTH,
      height: IMAGE_MOBILE_HEIGHT,
      label: `${IMAGE_MOBILE_WIDTH}×${IMAGE_MOBILE_HEIGHT} px (proporção 8:7)`
    };
  }

  return {
    width: IMAGE_WEB_WIDTH,
    height: IMAGE_WEB_HEIGHT,
    label: `${IMAGE_WEB_WIDTH}×${IMAGE_WEB_HEIGHT} px`
  };
};

export const isValidDestaqueImageSize = (width, height, tipoPlataformaId) => {
  const target = getDestaqueImageTarget(tipoPlataformaId);
  const minWidth = target.width * (1 - IMAGE_DIMENSION_TOLERANCE);
  const maxWidth = target.width * (1 + IMAGE_DIMENSION_TOLERANCE);
  const minHeight = target.height * (1 - IMAGE_DIMENSION_TOLERANCE);
  const maxHeight = target.height * (1 + IMAGE_DIMENSION_TOLERANCE);

  return (
    width >= minWidth &&
    width <= maxWidth &&
    height >= minHeight &&
    height <= maxHeight
  );
};

export const APLICATIVO_OPTIONS = [
  { value: 0, name: 'Todos' },
  { value: 1, name: 'Aplicativo 1' },
  { value: 2, name: 'Aplicativo 2' },
  { value: 3, name: 'Aplicativo 3' },
  { value: 4, name: 'Aplicativo 4' }
];

export const APLICATIVO_FORM_OPTIONS = [
  { value: '', name: 'Escolha' },
  { value: 1, name: 'Aplicativo 1' },
  { value: 2, name: 'Aplicativo 2' },
  { value: 3, name: 'Aplicativo 3' },
  { value: 4, name: 'Aplicativo 4' }
];

export const TIPO_PLATAFORMA_OPTIONS = [
  { value: '', name: 'Escolha' },
  { value: 1, name: 'Todos' },
  { value: 3, name: 'Site Computador' },
  { value: 4, name: 'Site Celular' },
  { value: 2, name: 'Aplicativo (Android e iOS)' }
];

export const TIPO_MODULO_HOME = 1;

export const TIPO_MODULO_OPTIONS = [
  { value: '', name: 'Escolha' },
  { value: 1, name: 'Home' },
  { value: 2, name: 'Cardápio' },
  { value: 3, name: 'Trabalhe Conosco' },
  { value: 4, name: 'Seja um Franqueado' },
  { value: 5, name: 'Sobre' }
];

export const TIPO_ACAO_OPTIONS = [
  { value: '', name: 'Escolha' },
  { value: 1, name: 'Atualizar Cadastro' }
];

export const getAplicativoLabel = (aplicativoId) => {
  const found = APLICATIVO_FORM_OPTIONS.find((item) => item.value === aplicativoId);
  return found ? found.name : aplicativoId != null ? String(aplicativoId) : '';
};

export const getDeepLinkingLabel = (deepLinking) => (deepLinking ? 'Sim' : 'Não');
